"use strict";

exports.__esModule = true;
exports.default = void 0;
const backgroundColor = ({
  theme,
  error,
  help
}) => {
  if (error) return theme.orbit.paletteRedNormal;
  if (help) return theme.orbit.paletteBlueNormal;
  return theme.orbit.paletteInkDark;
};
var _default = backgroundColor;
exports.default = _default;